try {
  const current = document.querySelector('product-recently-viewed[data-product-id]');
  const id = Number(current?.dataset.productId);
  const history = JSON.parse(localStorage.getItem('beyours:recently-viewed') || '[]');
  if (id && Array.isArray(history) && history.includes(id)) {
    localStorage.setItem('beyours:recently-viewed', JSON.stringify([id, ...history.filter(value => value !== id)].slice(0, 5)));
  }
} catch {}
if (!customElements.get('miloa-cart-suggestions')) {
  customElements.define('miloa-cart-suggestions', class extends HTMLElement {
    connectedCallback() {
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.loadRecent();
        }
      });
      this.observer.observe(this);
      this.addEventListener('click', event => {
        const button = event.target.closest('add-to-cart');
        if (!button) return;
        if (button.hasAttribute('disabled')) {
          event.stopImmediatePropagation();
          return;
        }
      }, true);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async loadRecent() {
      try {
        const history = JSON.parse(localStorage.getItem('beyours:recently-viewed') || '[]');
        if (!Array.isArray(history)) return;
        const ids = [...new Set(history.filter(id => /^\d+$/.test(String(id))))].slice(0, 5);
        if (!ids.length) return;
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('section_id', 'miloa-cart-recent');
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', ids.map(id => 'id:' + id).join(' OR '));
        const response = await fetch(url);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = Array.from(html.querySelectorAll('[data-miloa-recent-results] > li')).slice(0, 4);
        if (!cards.length || !this.isConnected) return;
        this.querySelector('h2').textContent = this.dataset.recentHeading;
        this.querySelector('ul').replaceChildren(...cards);
      } catch {}
    }
  });
}
